class Search {
    init() {
        // This manual functionality is required to prevent conflicts
        // with the ECP Filter Bar plugin
        this.searchWithEnterKey();
    }

    searchWithEnterKey() {
        document.querySelectorAll('form.search-form').forEach(search_form => {
            search_form.querySelector('input').addEventListener('keyup', (e) => {
                if(e.code == 'Enter') {
                    search_form.submit();

                    e.stopPropagation();
                    e.preventDefault();
                }
            });
        });
    }
}

export default Search;